import type { CoachingConfig } from '@efdigital/ll-addon-data/types/coaching/coaching-config';
import { findAllCoachingConfigs } from '@efdigital/ll-admin-v2/data/builders/xceed/coaching-configs';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingConfigsIndexModel = {
  coachingConfigs: CoachingConfig[];
};

export default class CoachingConfigsIndexRoute extends Route<CoachingConfigsIndexModel> {
  @service declare store: Store;

  async model() {
    const result = await this.store
      .request(findAllCoachingConfigs())
      .catch(() => null);
    return {
      coachingConfigs: result?.content.data ?? [],
    };
  }
}
